module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_03_quiz.e7a4afc2.png";